export default __webpack_public_path__ + "static/media/background.f667a7c4.jpg";